var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defaultRendererConfig, setupBingAerialImagery } from "./index";
import { sceneFlyover } from "./utils/sceneFlyover";
export function instancedMeshTilesetFlyover1(container, description) {
    return __awaiter(this, void 0, void 0, function* () {
        description.innerHTML =
            "<h1>" +
                "Instanced Mesh Tileset Flyover 1" +
                "</h1>" +
                "<p>" +
                "The camera will fly over an instanced mesh tileset. The tileset should render normally." +
                "</p>";
        const initialWait = 3;
        const time = 4;
        const durations = [0, initialWait, time, time];
        const positions = [
            { longitude: -1.3196787574172821, latitude: 0.6988877540027633, height: 5.3449065252786045 },
            { longitude: -1.3196787574172821, latitude: 0.6988877540027633, height: 5.3449065252786045 },
            { longitude: -1.3196933019624886, latitude: 0.6988834902970045, height: 5.088054644286 },
            { longitude: -1.319757010840286, latitude: 0.6989616342093943, height: 354.876924101454 },
        ];
        const focuses = [
            { longitude: -1.319679586643573, latitude: 0.6988869711449703, height: 4.207071155043818 },
            { longitude: -1.319679586643573, latitude: 0.6988869711449703, height: 4.207071155043818 },
            { longitude: -1.319679798873687, latitude: 0.6988804865535719, height: 4.416621796690002 },
            { longitude: -1.319679798873687, latitude: 0.6988804865535719, height: 4.416621796690002 },
        ];
        yield sceneFlyover(defaultRendererConfig(container), durations, positions, focuses, (renderer, camera) => __awaiter(this, void 0, void 0, function* () {
            // Scene setup
            setupBingAerialImagery(renderer);
            const object = yield renderer.getObjectFactory().createTileset({
                type: "direct",
                url: "https://s3.ap-southeast-2.amazonaws.com/skand.development.nathan.tiler-test-content/models/TilesetWithTreeBillboards/tileset.json",
            });
            renderer.getWorld().addObject(object);
        }));
    });
}
